import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';

export const selectVenueTypeCapsulesState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.VENUE_TYPE_CAPSULE];

export const selectVenueTypeCapsuleState = (state: State, widgetKey: string) =>
    selectVenueTypeCapsulesState(state)[widgetKey];
